import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import Datetime from 'react-datetime';
import moment from 'moment';
import 'moment/locale/de';
import enhanceWithClickOutside from 'react-click-outside';
import Icon from '../Icon';
var AppConfig = require('../../../config.json');

/**
 * InputOrderFormDateBirthday for any form.
 */

const child = Datetime.moment().subtract(5,'year').add(1, 'day');
const maxChild = Datetime.moment().subtract(100,'year');
const adult = Datetime.moment().subtract(18,'year').add(1, 'day');
const max100 = Datetime.moment().subtract(100,'year');
const id = uniqueId('input_'); 
const dateFormat = AppConfig.dateFormat; 

class InputOrderFormDateBirthday extends React.Component {
	constructor(props) {
	    super(props);
	    this.onFocus = this.onFocus.bind(this);
	    this.onBlur = this.onBlur.bind(this);
	    this.toggleCalendar = this.toggleCalendar.bind(this);
	    this.handleCalendarChange = this.handleCalendarChange.bind(this);
	    this.doVerify = this.doVerify.bind(this);
	    this.state = {isFocused: false, isFilled: false, hasError: false, errorMsg:'', isOpen: false, date:(this.props.adult?adult:child)};
	}
	componentDidMount() {
		if(this.props.value!=='') {
			this.fieldInput.value = this.props.value;
			this.setState({date: moment(this.props.value, dateFormat)});
		}
		if(this.fieldInput.value!=='') {
			this.setState({isFilled: true});
		}
	}
	onFocus(e) {
		this.setState({isFocused: true});
	}
	onBlur(e) {
		this.setState({isFocused: false});
		if(this.fieldInput.value!=='') {
			this.setState({isFilled: true});
		}
		this.doVerify();
	}
	handleClickOutside() {
		if(this.state.isOpen) {
		   this.toggleCalendar();
		}
	 }
	doVerify() {
		var hasError = false, errorMsg = '';
		if(this.props.required && this.fieldInput.value==='') {
			hasError = true;
			errorMsg = 'Dieses Feld wird benötigt.';
		} else if(this.fieldInput.value!=='') {
			var t = moment(this.fieldInput.value, dateFormat);
				
			if(this.props.adult) {
				if(!t.isValid() || t<max100 || t>adult) {
					hasError = true;
					errorMsg = 'Bitte geben Sie ein gültiges Datum an (TT.MM.JJJJ).';
				}
			} else {
				if(!t.isValid() || t<maxChild || t>child) {
					hasError = true;
					errorMsg = 'Bitte ein gültiges Datum für Ihr Kind angeben (TT.MM.JJJJ).';
				}
			}
		}
		this.setState({hasError: hasError, errorMsg: errorMsg});
		if(!hasError) {
			const newDate = moment(this.fieldInput.value, dateFormat);
			this.fieldInput.value = newDate.format(dateFormat);
			this.setState({date: newDate});
		}
		this.props.onChange(this.fieldInput, hasError, this.props.itemkey);
	}
	handleCalendarChange(e) {
		this.fieldInput.value = e.format(dateFormat);
		this.setState({hasError: false, errorMsg: '', isFilled: true, date:e});
	   	this.toggleCalendar();
	   	this.doVerify();
	}
	validDate(currentDate, selectedDate) {
		return currentDate.isBefore( adult ) && currentDate.isAfter(max100);
	}
	validDateChild(currentDate, selectedDate) {
		return currentDate.isBefore( child ) && currentDate.isAfter(maxChild);
	}
	toggleCalendar() {
		var newState = !this.state.isOpen;
		this.setState({isOpen: newState});
	}
    render () {
    	
		const classNames = (this.state.isFocused?"focused ":"")+(this.state.isFilled?"filled ":"")+(this.state.hasError?"error ":"")+"inputfield dateselect";
		
		return (
			<div className={classNames}>
				<input autoCapitalize="off" autoCorrect="off" id={id} type="text" name={this.props.name} onFocus={this.onFocus} onBlur={this.onBlur} ref={(input) => { this.fieldInput = input; }}  />
				<label htmlFor={id}>{this.props.label}{this.props.required?"*":""}</label>
				<Icon filename="calendar" onClick={() => this.toggleCalendar()} />
				{this.state.hasError && this.state.errorMsg!==''?<div className="errormsg">{this.state.errorMsg}</div>:null}
				{this.state.isOpen?
					<div className="calendar">
					<Datetime
					value={this.state.date}
					input={false}
					locale="de"
					onChange={this.handleCalendarChange}
					dateFormat={dateFormat}
					timeFormat={false}
					isValidDate={(this.props.adult?this.validDate:this.validDateChild)} /></div>
					:null
				}
			</div>
		)
    }

}
InputOrderFormDateBirthday.propTypes = {
	/** InputOrderFormDateBirthday verify */
	verify: PropTypes.string,
	/** InputOrderFormDateBirthday required */
	required: PropTypes.bool,
	/** InputOrderFormDateBirthday value */
	value: PropTypes.string,
	/** InputOrderFormDateBirthday value */
	itemkey: PropTypes.string,
	/** InputOrderFormDateBirthday Label */
	label: PropTypes.string.isRequired,
	/** InputOrderFormDateBirthday adult */
	adult: PropTypes.bool,
}


InputOrderFormDateBirthday.defaultProps = {
  value: "",
  itemkey: "",
  required: false,
  adult: true
}

export default enhanceWithClickOutside(InputOrderFormDateBirthday);




// WEBPACK FOOTER //
// ./src/components/atoms/InputOrderFormElements/InputOrderFormDateBirthday.js